
import React from 'react'

const Losers = () => {
  return (
    <div>Losers</div>
  )
}

export default Losers